import React from 'react';
import { FRESHNESS_MONTHS, freshShare, formatFreshShare } from './freshness';

export const RatingItem = ({ item, ageMonths = FRESHNESS_MONTHS, isSelected = false, onSelect = () => {} }) => {
  const updated = new Date(item.updatedAt).toLocaleString("ru", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });
  // Показываем долю свежих работ по тому же порогу, который выбран в фильтре: колонка и
  // ползунок должны говорить об одном и том же, иначе результат фильтрации нечем проверить.
  const fresh = freshShare(item.avgCreationDate, ageMonths);
  return (
    <tr
      className={`rating-row${isSelected ? ' selected' : ''}`}
      onClick={() => onSelect(item)}
    >
      <td>{updated}</td>
      <td className="cell-keyword">
        {/* Ссылка ведёт на Adobe — stopPropagation, чтобы клик по ней не переключал ещё и график */}
        <a
          href={item.url}
          target="_blank"
          rel="noreferrer"
          title={item.keyword}
          onClick={(e) => e.stopPropagation()}
        >
          {item.keyword}
        </a>
      </td>
      <td className="col-type"><span className={`badge-type badge-${item.contentType.toLowerCase()}`}>{item.contentType}</span></td>
      {/* totalResults допускает null (не спарсился с страницы Adobe) — прочерк, чтобы это не
          выглядело как ноль работ в выдаче. ?? , а не || — реальный 0 должен показываться. */}
      {/* Разряды через запятую: en-US жёстко, а не по локали интерфейса — Adobe Stock и сам
          пишет «35,889,492», и цифра должна совпадать с тем, что видно на его странице. */}
      <td>{item.totalResults == null ? '—' : Number(item.totalResults).toLocaleString('en-US')}</td>
      {/* Доля свежих работ. Прочерк — свежесть неизвестна (запись сохранена до появления
          imageIds), и это не то же самое, что «0% свежих». */}
      <td>{formatFreshShare(fresh)}</td>
      <td className="cell-score"><strong>{item.score}</strong></td>
      <td className="cell-level col-level">{item.level}</td>
      <td>{item.averageRating.toFixed(0)}</td>
      <td className="col-density">
        <div className="density-info">
          <span>Top: {item.topDensity}%</span>
          <span>Elite: {item.eliteDensity}%</span>
        </div>
      </td>
    </tr>
  );
};